<script setup>
import SearchBarInput from '~/components/UI/SearchBarInput.vue'
import NotificationsDropdown from '~/components/Common/NotificationsDropdown.vue'

const Breadcrumb = defineAsyncComponent(() => import('@/components/Common/Breadcrumb.vue'))

const { t } = useI18n()
const { clear } = useSearch()
const { toggle } = useMobileMenu()

// Query local para el input
const searchQuery = ref('')

// El componente SearchBarInput ya maneja la búsqueda internamente
// No es necesario hacer nada aquí, solo log para debugging si es necesario
const handleSearch = () => {
  // La búsqueda ya se realizó en el componente SearchBarInput
  // mediante searchWithTypes, no llamamos a search() aquí
}

// Limpiar búsqueda
const handleClear = () => {
  searchQuery.value = ''
  clear()
}
</script>

<template>
  <header class="relative border-b border-slate-200 bg-white z-30">
    <div class="flex items-center justify-between px-4 md:px-8 py-3">
      <button
        class="md:hidden p-2 -ml-2 text-slate-500 hover:text-slate-700 hover:bg-slate-100 rounded-lg transition-colors"
        @click="toggle"
      >
        <Icon name="material-symbols:menu" class="text-2xl" />
      </button>

      <div class="hidden md:block">
        <ClientOnly>
          <Breadcrumb />
        </ClientOnly>
      </div>

      <div class="flex items-center justify-end gap-3 flex-1 max-w-2xl">
        <SearchBarInput
          class="flex-1 md:flex-none xl:min-w-[350px]"
          v-model="searchQuery"
          :placeholder="t('search.placeholders.global')"
          :debounce-ms="300"
          :min-length="2"
          :show-filter-dropdown="true"
          @search="handleSearch"
          @clear="handleClear"
        >
          <template #icon>
            <Icon name="material-symbols:search" class="text-[20px]" />
          </template>
        </SearchBarInput>

        <div class="flex gap-3">
          <NotificationsDropdown />
        </div>
      </div>
    </div>

    <div class="md:hidden px-4 pb-3 overflow-x-auto">
      <ClientOnly>
        <Breadcrumb />
      </ClientOnly>
    </div>
  </header>
</template>
